/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enums_Notitietype_Rapport3Inputs */

const nl_enums_notitietype_rapport3 = /** @type {(inputs: Enums_Notitietype_Rapport3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rapport`)
};

/**

* @param {Enums_Notitietype_Rapport3Inputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const enums_notitietype_rapport3 = /** @type {((inputs?: Enums_Notitietype_Rapport3Inputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enums_Notitietype_Rapport3Inputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_enums_notitietype_rapport3(inputs)
});
export { enums_notitietype_rapport3 as "enums.NotitieType.Rapport" }